import { IEventSubscription } from "../../domain/events/IEventSubscription";
import React from "react";

export class BaseComponent<P = {}, S = {}, SS = any> extends React.Component<P, S, SS> {
    protected mounted = false;
    private _subscriptions: IEventSubscription[];
    constructor(props: P) {
      super(props);
      this._subscriptions = [];
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
      this.mounted = false;
      this._subscriptions.forEach(s => s.unsubscribe());
    }
    addEventListener(element: EventTarget, event: string, handler: EventListenerOrEventListenerObject) {
        element.addEventListener(event,  handler);
        this._subscriptions.push({ unsubscribe: () => element.removeEventListener(event, handler) });
    }
    // subscribe(event: string, fn: (data: any) => void) {
    //   return appDomain.IEventHandler.subscribe(event, fn);
    // }
    subscribeInterval(fn: Function, ms: number): void {
        const interval = setInterval(fn, ms);
        this._subscriptions.push({ unsubscribe: () => clearInterval(interval) });
    }
    // translate(key: string, params?: any): string {
    //   return appDomain.IRequestTranslation.translate(key, params);
    // }
    // navigateTo(url: string, params: any = {}): void {
    //   appDomain.INavigator.navigateTo(url, params);
    // }
  }
